// Тексты страницы «Школам» (30.10.2026): RU и AZ — из документа владельца
// «Страница «Школам» — тексты», EN — перевод с RU (на проверке у владельца).
// Служебная строка документа «Факты сверены…» не публикуется.
//
// ЦЕНЫ НЕ ПИШЕМ ЧИСЛАМИ: {career} и {climate} подставляются из тех же строк,
// что у таблицы цен на главной (design/content/ru.json: 25_student,
// 8_per_student_a_year_first_round_free). Меняется цена там — меняется и здесь.
import ru from "../../../design/content/ru.json";
import type { SiteLang } from "@/components/site/SiteChrome";

export const SCHOOLS_PATH: Record<SiteLang, string> = { az: "/az/mektebler", ru: "/ru/shkolam", en: "/en/schools" };

const num = (s: string) => {
  const m = /\d+/.exec(s);
  if (!m) throw new Error(`в строке цены нет числа: ${s}`);
  return Number(m[0]);
};
/** Цены школьных программ, ₼ за ученика (климат — за год) — из строк таблицы цен главной. */
export const SCHOOL_PRICES = {
  career: num(ru["25_student"]),
  climate: num(ru["8_per_student_a_year_first_round_free"]),
};
/** Подставить {career} / {climate}. */
export const withPrices = (s: string) => s.replace(/\{career\}/g, String(SCHOOL_PRICES.career)).replace(/\{climate\}/g, String(SCHOOL_PRICES.climate));

type Bullet = { b?: string; t: string };
export type SchoolsCopy = {
  meta: { title: string; description: string };
  h1: string;
  sub: string;
  ctaForm: string;
  ctaSample: string;
  note: string;
  programsTitle: string;
  career: { title: string; tag: string; lead: string; bullets: Bullet[]; methodLink: string };
  climate: { title: string; tag: string; lead: string; bullets: Bullet[] };
  stepsTitle: string;
  steps: Bullet[];
  reviewTitle: string;
  reviewWho: string;
  privacyTitle: string;
  privacy: string[];
  privacyLink: string;
  faqTitle: string;
  faq: { q: string; a: string }[];
  finalTitle: string;
  finalText: string;
  form: { school: string; schoolPh: string; position: string; positionPh: string };
};

export const SCHOOLS_COPY: Record<SiteLang, SchoolsCopy> = {
  ru: {
    meta: {
      title: "Профориентация для школ и опрос о климате в классе — Yolutap",
      description: "Профориентация для 7–11 классов ({career} ₼ за ученика) и анонимный опрос о климате и травле для 4–11 классов ({climate} ₼, первый тур бесплатно). Отчёт на каждого ученика и картина по классам.",
    },
    h1: "Профориентация и климат в классе — для школ",
    sub: "Ученики понимают свои сильные стороны и направления, а школа видит, что происходит в классах, — в цифрах, а не по ощущениям.",
    ctaForm: "Обсудить для школы →",
    ctaSample: "Образец отчёта",
    note: "Тест на азербайджанском, русском и английском · Данные хранятся в ЕС · С нами работает European Azerbaijan School",
    programsTitle: "Две программы",
    career: {
      title: "Профориентация для классов",
      tag: "7–11 классы · {career} ₼ за ученика",
      lead: "Научный профиль для всей параллели и картина по классам для школы.",
      bullets: [
        { b: "Ученик", t: "проходит тест примерно за 30 минут и получает свой профиль: архетип, сильные стороны, три карьерных направления. Тест подстроен под возраст: отдельные версии для 12–13, 14–15 и 16–18 лет." },
        { b: "Школа", t: "получает картину по классам: какие интересы и направления преобладают — опора для профильных классов, кружков и работы с родителями." },
        { b: "Методика", t: "опирается на три классические теории — Супера, Холланда и Пиаже ({method})." },
        { t: "Результаты — в PDF за 1–2 дня." },
      ],
      methodLink: "подробнее о методике",
    },
    climate: {
      title: "Климат школы",
      tag: "4–11 классы · {climate} ₼ за ученика в год · первый тур бесплатно",
      lead: "Анонимный опрос на 15 минут о том, как детям в классе: чувствуют ли они себя в безопасности, есть ли травля.",
      bullets: [
        { b: "Анонимно.", t: "Результаты показываются только по группам, где 10 и больше ответов — конкретного ребёнка узнать нельзя." },
        { b: "3–4 тура за учебный год", t: "входят в {climate} ₼ — чтобы видеть, меняется ли ситуация в течение года." },
        { b: "Первый тур бесплатно", t: "— школа видит результат до того, как платить." },
      ],
    },
    stepsTitle: "Как проходит работа",
    steps: [
      { b: "Заявка.", t: "Школа оставляет контакт в форме, мы связываемся и обсуждаем классы, язык и сроки." },
      { b: "Договорённость.", t: "Согласование с администрацией; для учеников младше 18 лет — согласие родителей, его собирает школа." },
      { b: "Прохождение.", t: "Около 30 минут на профориентацию или 15 минут на опрос о климате. Как удобнее школе: с телефонов, в компьютерном классе или дома." },
      { b: "Результаты.", t: "Ученики получают свои профили, школа — картину по классам — в PDF за 1–2 дня." },
    ],
    reviewTitle: "С нами работает",
    reviewWho: "European Azerbaijan School, 7–10 классы",
    privacyTitle: "Данные и приватность",
    privacy: [
      "Данные хранятся в ЕС (Франкфурт), мы их не продаём.",
      "Для учеников младше 18 лет нужно согласие родителей.",
      "Опрос о климате анонимный: школа видит только группы от 10 ответов.",
      "Личный профиль ученика видят сам ученик, его родители и школа. Подробнее — в {privacy}.",
    ],
    privacyLink: "Политике конфиденциальности",
    faqTitle: "Вопросы и ответы",
    faq: [
      { q: "Сколько это стоит?", a: "Профориентация — {career} ₼ за ученика. Климат школы — {climate} ₼ за ученика в год (3–4 тура), первый тур бесплатно." },
      { q: "Сколько времени занимает?", a: "Профориентационный тест — около 30 минут, можно сделать паузу. Опрос о климате — 15 минут." },
      { q: "На каких языках?", a: "На азербайджанском, русском и английском — каждый ученик выбирает свой." },
      { q: "Чем это отличается от обычного теста из интернета?", a: "Тест построен на трёх научных теориях и адаптирован под возраст. В нём нет правильных и неправильных ответов, поэтому отчёт описывает ученика таким, какой он есть, а не таким, каким хочет казаться. Отчёт — инструмент для разговора, а не диагноз." },
      { q: "Кто видит результаты?", a: "Профиль ученика — сам ученик, его родители и школа. Результаты опроса о климате — только по группам от 10 ответов, без имён." },
    ],
    finalTitle: "Обсудим вашу школу",
    finalText: "Оставьте контакт — расскажем, как провести профориентацию или опрос о климате в ваших классах. Или напишите в WhatsApp: {whatsapp}.",
    form: { school: "Школа", schoolPh: "Название школы", position: "Должность", positionPh: "Например, заместитель директора" },
  },
  az: {
    meta: {
      title: "Məktəblər üçün peşəyönümü və sinif iqlimi sorğusu — Yolutap",
      description: "7–11-ci siniflər üçün peşəyönümü (şagird başına {career} ₼) və 4–11-ci siniflər üçün iqlim və zəbt-zoraklıq barədə anonim sorğu ({climate} ₼, ilk tur pulsuz). Hər şagird üçün hesabat və siniflər üzrə mənzərə.",
    },
    h1: "Məktəblər üçün peşəyönümü və sinif iqlimi",
    sub: "Şagirdlər güclü tərəflərini və istiqamətlərini anlayır, məktəb isə siniflərdə nə baş verdiyini hisslərlə yox, rəqəmlərlə görür.",
    ctaForm: "Məktəb üçün müzakirə et →",
    ctaSample: "Nümunə hesabat",
    note: "Test Azərbaycan, rus və ingilis dillərində · Məlumatlar AB-də saxlanılır · Bizimlə European Azerbaijan School işləyir",
    programsTitle: "İki proqram",
    career: {
      title: "Siniflər üçün peşəyönümü",
      tag: "7–11-ci siniflər · şagird başına {career} ₼",
      lead: "Bütün paralel üçün elmi profil və məktəb üçün siniflər üzrə mənzərə.",
      bullets: [
        { b: "Şagird", t: "testi təxminən 30 dəqiqəyə keçir və öz profilini alır: arxetip, güclü tərəflər, üç karyera istiqaməti. Test yaşa uyğunlaşdırılıb: 12–13, 14–15 və 16–18 yaş üçün ayrıca versiyalar var." },
        { b: "Məktəb", t: "siniflər üzrə mənzərəni alır: hansı maraqlar və istiqamətlər üstünlük təşkil edir — profil sinifləri, dərnəklər və valideynlərlə iş üçün dəstək." },
        { b: "Metodika", t: "üç klassik nəzəriyyəyə əsaslanır — Super, Holland və Piaje ({method})." },
        { t: "Nəticələr 1–2 gün ərzində PDF formasında təqdim olunur." },
      ],
      methodLink: "metodika barədə ətraflı",
    },
    climate: {
      title: "Məktəb iqlimi",
      tag: "4–11-ci siniflər · şagird başına ildə {climate} ₼ · ilk tur pulsuz",
      lead: "Uşaqların sinifdə özlərini necə hiss etdiyi barədə 15 dəqiqəlik anonim sorğu: özlərini təhlükəsizlikdə hiss edirlərmi, zəbt-zoraklıq varmı.",
      bullets: [
        { b: "Anonim.", t: "Nəticələr yalnız 10 və daha çox cavab olan qruplar üzrə göstərilir — konkret uşağı müəyyən etmək mümkün deyil." },
        { b: "Tədris ili ərzində 3–4 tur", t: "{climate} ₼-yə daxildir — vəziyyətin il ərzində dəyişib-dəyişmədiyini görmək üçün." },
        { b: "İlk tur pulsuzdur", t: "— məktəb ödənişdən əvvəl nəticəni görür." },
      ],
    },
    stepsTitle: "İş necə qurulur",
    steps: [
      { b: "Müraciət.", t: "Məktəb formada əlaqə məlumatını qoyur, biz əlaqə saxlayıb sinifləri, dili və müddətləri müzakirə edirik." },
      { b: "Razılaşma.", t: "Rəhbərliklə razılaşdırma; 18 yaşdan kiçik şagirdlər üçün valideyn razılığı lazımdır, onu məktəb toplayır." },
      { b: "Keçirilmə.", t: "Peşəyönümü testi təxminən 30 dəqiqə, iqlim sorğusu 15 dəqiqə çəkir. Məktəb üçün necə rahatdırsa: telefondan, kompüter sinfində və ya evdə." },
      { b: "Nəticələr.", t: "Şagirdlər öz profillərini, məktəb isə siniflər üzrə mənzərəni 1–2 gün ərzində PDF formasında alır." },
    ],
    reviewTitle: "Bizimlə işləyir",
    reviewWho: "European Azerbaijan School, 7–10-cu siniflər",
    privacyTitle: "Məlumatlar və məxfilik",
    privacy: [
      "Məlumatlar AB-də (Frankfurt) saxlanılır, biz onları satmırıq.",
      "18 yaşdan kiçik şagirdlər üçün valideyn razılığı tələb olunur.",
      "İqlim sorğusu anonimdir: məktəb yalnız 10 və daha çox cavablı qrupları görür.",
      "Şagirdin şəxsi profilini şagirdin özü, valideynləri və məktəb görür. Ətraflı — {privacy}.",
    ],
    privacyLink: "Məxfilik Siyasətində",
    faqTitle: "Suallar və cavablar",
    faq: [
      { q: "Bu neçəyə başa gəlir?", a: "Peşəyönümü — şagird başına {career} ₼. Məktəb iqlimi — şagird başına ildə {climate} ₼ (3–4 tur), ilk tur pulsuzdur." },
      { q: "Nə qədər vaxt tələb edir?", a: "Peşəyönümü testi təxminən 30 dəqiqə çəkir, fasilə vermək olar. İqlim sorğusu — 15 dəqiqə." },
      { q: "Hansı dillərdə?", a: "Azərbaycan, rus və ingilis dillərində — hər şagird öz dilini seçir." },
      { q: "Bu, internetdəki adi testdən nə ilə fərqlənir?", a: "Test üç elmi nəzəriyyə əsasında qurulub və yaşa uyğunlaşdırılıb. Burada düz və ya səhv cavab yoxdur, ona görə hesabat şagirdi olmaq istədiyi kimi yox, olduğu kimi təsvir edir. Hesabat diaqnoz deyil, söhbət üçün alətdir." },
      { q: "Nəticələri kim görür?", a: "Şagirdin profilini — şagirdin özü, valideynləri və məktəb. İqlim sorğusunun nəticələri — yalnız 10 və daha çox cavablı qruplar üzrə, adlar olmadan." },
    ],
    finalTitle: "Məktəbinizi müzakirə edək",
    finalText: "Əlaqə məlumatınızı qoyun — siniflərinizdə peşəyönümünü və ya iqlim sorğusunu necə keçirəcəyimizi danışaq. Və ya WhatsApp-a yazın: {whatsapp}.",
    form: { school: "Məktəb", schoolPh: "Məktəbin adı", position: "Vəzifə", positionPh: "Məsələn, direktor müavini" },
  },
  en: {
    meta: {
      title: "Career guidance for schools and class climate survey — Yolutap",
      description: "Career guidance for grades 7–11 ({career} ₼ per student) and an anonymous survey on climate and bullying for grades 4–11 ({climate} ₼, first round free). A report for every student and a picture by class.",
    },
    h1: "Career guidance and class climate — for schools",
    sub: "Students understand their strengths and directions, and the school sees what is happening in its classes — in numbers, not impressions.",
    ctaForm: "Discuss for your school →",
    ctaSample: "Sample report",
    note: "Test in Azerbaijani, Russian and English · Data stored in the EU · European Azerbaijan School works with us",
    programsTitle: "Two programmes",
    career: {
      title: "Career guidance for classes",
      tag: "Grades 7–11 · {career} ₼ per student",
      lead: "A science-based profile for the whole year group and a picture by class for the school.",
      bullets: [
        { b: "Each student", t: "takes the test in about 30 minutes and gets their own profile: archetype, strengths and three career directions. The test is age-adapted, with separate versions for ages 12–13, 14–15 and 16–18." },
        { b: "The school", t: "gets a picture by class: which interests and directions prevail — support for specialised classes, clubs and work with parents." },
        { b: "The method", t: "draws on three classic theories — Super, Holland and Piaget ({method})." },
        { t: "Results in PDF within 1–2 days." },
      ],
      methodLink: "more about the method",
    },
    climate: {
      title: "School climate",
      tag: "Grades 4–11 · {climate} ₼ per student a year · first round free",
      lead: "An anonymous 15-minute survey on how children feel in class: whether they feel safe and whether there is bullying.",
      bullets: [
        { b: "Anonymous.", t: "Results are shown only for groups with 10 or more responses — no individual child can be identified." },
        { b: "3–4 rounds per school year", t: "are included in the {climate} ₼ — to see whether things change over the year." },
        { b: "The first round is free", t: "— the school sees the result before paying." },
      ],
    },
    stepsTitle: "How it works",
    steps: [
      { b: "Request.", t: "The school leaves its contact details in the form; we get in touch and discuss classes, language and timing." },
      { b: "Agreement.", t: "Approval by the school leadership; for students under 18, parental consent, which the school collects." },
      { b: "Taking part.", t: "About 30 minutes for career guidance or 15 minutes for the climate survey. Whatever suits the school: on phones, in the computer lab or at home." },
      { b: "Results.", t: "Students get their profiles and the school gets a picture by class — in PDF within 1–2 days." },
    ],
    reviewTitle: "Working with us",
    reviewWho: "European Azerbaijan School, grades 7–10",
    privacyTitle: "Data and privacy",
    privacy: [
      "Data is stored in the EU (Frankfurt), and we do not sell it.",
      "Students under 18 need parental consent.",
      "The climate survey is anonymous: the school sees only groups of 10 or more responses.",
      "A student's personal profile is seen by the student, their parents and the school. More in the {privacy}.",
    ],
    privacyLink: "Privacy Policy",
    faqTitle: "Questions and answers",
    faq: [
      { q: "How much does it cost?", a: "Career guidance — {career} ₼ per student. School climate — {climate} ₼ per student a year (3–4 rounds), first round free." },
      { q: "How long does it take?", a: "The career guidance test takes about 30 minutes, and you can pause. The climate survey takes 15 minutes." },
      { q: "In which languages?", a: "Azerbaijani, Russian and English — each student chooses their own." },
      { q: "How is this different from an ordinary online test?", a: "The test is built on three scientific theories and adapted to age. There are no right or wrong answers, so the report describes the student as they are, not as they would like to appear. The report is a tool for a conversation, not a diagnosis." },
      { q: "Who sees the results?", a: "The student's profile — the student, their parents and the school. Climate survey results — only for groups of 10 or more responses, without names." },
    ],
    finalTitle: "Let's discuss your school",
    finalText: "Leave your contact details — we'll explain how to run career guidance or the climate survey in your classes. Or message us on WhatsApp: {whatsapp}.",
    form: { school: "School", schoolPh: "School name", position: "Position", positionPh: "For example, deputy head" },
  },
};

/** FAQPage для head — те же вопросы, что на странице, цены подставлены. */
export function schoolsFaqJsonLd(lang: SiteLang) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: SCHOOLS_COPY[lang].faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: withPrices(f.a) } })),
  };
}
